import { render, staticRenderFns } from "./certificate-manage.vue?vue&type=template&id=c9234a10&"
import script from "./certificate-manage.vue?vue&type=script&lang=js&"
export * from "./certificate-manage.vue?vue&type=script&lang=js&"
import style0 from "./certificate-manage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports